import React, {Component} from 'react';
import {Modal, ModalHeader} from "reactstrap";
import {FaIcon} from "../FaIcon";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {DATA_BY_BUDGET_TYPE} from "../../budgets";
import { withTranslation } from 'react-i18next';

class AdAccountBudgetWithDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            detailModalIsOpen: false,
            campaignsBudgetDetails: null
        };

        this.detailModalToggle = this.detailModalToggle.bind(this);
    }

    detailModalToggle() {
        const newDetailModalIsOpen = !this.state.detailModalIsOpen;
        this.setState({
            detailModalIsOpen: !this.state.detailModalIsOpen
        });

        if (!this.state.detailModalIsOpen && this.state.campaignsBudgetDetails === null)
            this.updateCampaignsBudgetDetails(newDetailModalIsOpen);
    }

    updateCampaignsBudgetDetails(newDetailModalIsOpen) {
        new APIClient(API_URL + `agency/ad-accounts/${this.props.adAccountId}/budgets`).call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this.setState({
                        campaignsBudgetDetails: response.data,
                        detailModalIsOpen: newDetailModalIsOpen
                    });
                } else {
                    alert(response.error_message)
                }
            });
    }

    renderShowDetailIcon() {
        const { t } = this.props;
        let modalContent = null;
        if (this.state.campaignsBudgetDetails !== null) {
            modalContent = <div className="section-body-item -wider box">
                <div className="table-box mt-">
                <table id="campaignBudgetsList" className="table table-striped">
                    <thead>
                    <tr>
                        <th>{t('ad_account_budget.campaign')}</th>
                        <th>{t('ad_account_budget.budget_type')}</th>
                        <th>{t('ad_account_budget.daily_budget')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.renderCampaignBudgetDetailsRows()}
                    </tbody>
                </table>
            </div><div className="field-footnote mt-2">{`${t('ad_account_budget.last_update')} ${this.props.campaignsLastUpdate}`}</div></div>;
        } else {
            modalContent = <div className="box-loader">
                <Spinner color="positive"/>
            </div>;
        }

        return (
            <span>
                <button className="edit-button" onClick={() => {
                    this.detailsModal.props.toggle()
                }}>
                    <FaIcon iconName={"info-circle"}/>
                </button>
                <Modal isOpen={this.state.detailModalIsOpen}
                       toggle={this.detailModalToggle}
                       className={this.props.className}
                       ref={instance => {
                           this.detailsModal = instance;
                       }}>
                    <ModalHeader toggle={this.toggle}>{t('ad_account_budget.modal_title')}</ModalHeader>
                    <div className="modal-section">
                        {modalContent}
                    </div>
                    {/*<ModalFooter></ModalFooter>*/}
                </Modal>
            </span>
        );
    }

    renderCampaignBudgetDetailsRows() {
        return this.state.campaignsBudgetDetails.map((campaignBudgetDetails) => (this.renderBudgetDetailsRow(campaignBudgetDetails)));
    }

    renderBudgetType(campaignBudgetDetails) {
        const { t } = this.props;
        if (!(campaignBudgetDetails.budget_detail.type in DATA_BY_BUDGET_TYPE))
            return t('ad_account_budget.budget_detection_error');

        const typeData = DATA_BY_BUDGET_TYPE[campaignBudgetDetails.budget_detail.type];
        let campaignPeriodText = '';
        let campaignTotal = null;
        let adsetsText = '';

        if(campaignBudgetDetails.budget_detail["lifetime_budget"]) {
            const formattedTotalBudget = `$${Number(campaignBudgetDetails.budget_detail["lifetime_budget"]).toFixed(0).toLocaleString('en-US')}`;
            campaignTotal = <span><br/>{t('ad_account_budget.total_budget')} {formattedTotalBudget}</span>
        }

        if (typeData["has_period"] && (campaignBudgetDetails.budget_detail["from_date"] || campaignBudgetDetails.budget_detail["to_date"])) {
            if (campaignBudgetDetails.budget_detail["from_date"] && campaignBudgetDetails.budget_detail["to_date"])
                campaignPeriodText = <span><br/>{campaignBudgetDetails.budget_detail["from_date"]} {t('ad_account_budget.to')} {campaignBudgetDetails.budget_detail["to_date"]}</span>;
            else if(campaignBudgetDetails.budget_detail["from_date"])
                campaignPeriodText = <span><br/>{t('ad_account_budget.from')} {campaignBudgetDetails.budget_detail["from_date"]}</span>;
        }

        if (typeData["has_adset_detail"]) {

            const adsets_data = campaignBudgetDetails.budget_detail.adsets_budget_details;
            const adsets_text = adsets_data.map((adsets) => {
                return this.renderAdsetDetails(adsets);
            });

            adsetsText = <span><br/><ul className="budget-list">{adsets_text}</ul></span>;
        }

        return <div className="mt-2 mb-2">{typeData["title"]}{campaignPeriodText}{campaignTotal}{adsetsText}</div>;
    }

    renderAdsetDetails(adsets) {
        const { t } = this.props;
        let adgroupPeriodText = null;
        if (adsets.from_date && adsets.to_date)
            // En la fecha Hasta se muestra el dia anterior porque puede ser mas entendible para el usuario (asi salio de la UI de Tiktok)
            adgroupPeriodText = <li>{this.formatDateFromString(adsets.from_date)} {t('ad_account_budget.to')} {this.formatDateFromString(adsets.to_date, false)}</li>;
        else if (adsets.from_date)
            adgroupPeriodText = <li>{t('ad_account_budget.from')} {adsets.from_date}</li>;

        let adsetDailyBudget = null;
        if(adsets.daily_budget) {
            const formattedDailyBudget = `$${Number(adsets.daily_budget).toFixed(0).toLocaleString('en-US')}`;
            adsetDailyBudget = <li>{t('ad_account_budget.daily_budget_label')} {formattedDailyBudget}</li>
        }

        let adsetTotalBudget = null;
        if(adsets.total_budget){
            const formattedTotalBudget = adsets.total_budget ? `$${Number(adsets.total_budget).toFixed(0).toLocaleString('en-US')}` : null;
            adsetTotalBudget = <li>{t('ad_account_budget.total_budget_label')} {formattedTotalBudget}</li>;
        }
        const adsetDetails = adsetTotalBudget || adsetDailyBudget || adgroupPeriodText ? <ul>{adgroupPeriodText}{adsetTotalBudget}{adsetDailyBudget}</ul> : null;
        return <li>{adsets.name}{adsetDetails}</li>;
    }

    formatDateFromString(dateAsYYYMMDD, goOneDayBefore= false) {
        const year = parseInt(dateAsYYYMMDD.substring(0, 4), 10);
        const month = parseInt(dateAsYYYMMDD.substring(4, 6), 10) - 1;  // Months are 0-based in JS
        const day = parseInt(dateAsYYYMMDD.substring(6, 8), 10);

        if(!goOneDayBefore)
            return day + "/" + (month+1) + "/" + year;

        const aDate = new Date(year, month, day);
        aDate.setDate(aDate.getDate() - 1);  // Subtract one day

        return this.formatDateToDDMMYYYY(aDate);
    }

    formatDateToDDMMYYYY(date) {
        const day = String(date.getDate()).padStart(2, '0');    // Get day and pad with zero if needed
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-based) and pad with zero
        const year = date.getFullYear();                        // Get full year

        return `${day}/${month}/${year}`;
    }

    renderBudgetDetailsRow(campaignBudgetDetails) {
        const formattedDailyBudget = parseInt(campaignBudgetDetails.budget_detail.daily_budget, 10).toLocaleString('en-US');

        return (
            <tr key={campaignBudgetDetails.campaign_id}>
                <td style={{maxWidth:"200px"}}>
                    {campaignBudgetDetails.campaign_name}
                </td>
                <td>
                    {this.renderBudgetType(campaignBudgetDetails)}
                </td>
                <td className="text-right">
                    {`$ ${formattedDailyBudget}`}
                </td>
            </tr>
        );
    }

    render() {
        const { t } = this.props;
        if (this.props.channelHasBudgets === false)
            return "-";

        if (this.props.hasAccess === false)
            return <div className="field-footnote-darker mt-2">{t('ad_account_budget.no_access')}</div>;

        if (this.props.hasInternalProblem === true)
            return <div className="field-footnote-darker mt-2">{t('ad_account_budget.account_disabled')}</div>;

        if (this.props.campaignsLastUpdate === null || this.props.dailyBudget === null)
            return <div className="field-footnote mt-2">{t('ad_account_budget.no_information')}</div>;


        const formattedDailyBudget = parseInt(this.props.dailyBudget, 10).toLocaleString('en-US');
        const formattedMaxCampaignDailyBudget =  parseInt(this.props.maxCampaignDailyBudget, 10).toLocaleString('en-US');

        return <span>{this.props.currency}$ {formattedDailyBudget} ({t('ad_account_budget.max_campaign')} {this.props.currency}$ {formattedMaxCampaignDailyBudget}){this.renderShowDetailIcon()}</span>
    }
}

export default withTranslation()(AdAccountBudgetWithDetails);
